import referrerLoader from './referrerLoader';

const loaders = {
    referrer: referrerLoader
}

export default loaders;